import { buildEducationFormSchema } from '../../../../common';

export const EDUCATION_FORM_SCHEMA = buildEducationFormSchema({ richTextDescriptions: true });
